@if (visible) {
  <div class="migration-notice" role="status" data-cy="aviso migracion services a flows">
    <span class="migration-notice__text">
      Ahora podrás gestionar todo lo relacionado a tus contratos directamente desde Flows
      <a [routerLink]="[link]" class="migration-notice__link">Conoce más aquí</a>
    </span>
    <button type="button" class="migration-notice__close" aria-label="Cerrar aviso" (click)="dismiss()">
      <i class="fas fa-times"></i>
    </button>
  </div>
}
